/**
 * Mediterranean Palette
 * Vibrant, warm, culturally rich
 */

import { ThemeColors } from '../../assets/theme';

export const mediterraneanLight: ThemeColors = {
  // Primary palette - Sea blue with Aegean teal
  primary: '#2E86AB',
  primaryLight: '#4A9BC7',
  primaryDark: '#1F5F7A',

  // Secondary palette - Terracotta and olive
  secondary: '#C85A39',
  secondaryLight: '#D97352',
  secondaryDark: '#B04120',

  // Accent colors - Sun yellow and lavender
  accent: '#F4A261',
  accentLight: '#F7B885',
  accentDark: '#E88C3D',

  // Neutral palette - Warm whites and soft grays
  background: '#FFF8F0',
  surface: '#FFFFFF',
  surfaceHover: '#FFF5E8',

  // Text colors
  text: '#2C2416',
  textSecondary: '#6B5D47',
  textMuted: '#9B8E7A',

  // Status colors
  success: '#28A745',
  warning: '#FFC107',
  error: '#DC3545',
  info: '#17A2B8',

  // Border and divider
  border: '#E8DCC8',
  borderLight: '#F1E8D8',
  divider: '#D4C4B0',

  // Shadows - Warm-tinted
  shadow: 'rgba(46, 134, 171, 0.1)',
  shadowHover: 'rgba(46, 134, 171, 0.15)',
  shadowDark: 'rgba(46, 134, 171, 0.2)',

  // Overlays
  overlay: 'rgba(46, 134, 171, 0.6)',
  overlayLight: 'rgba(46, 134, 171, 0.1)',

  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #2E86AB 0%, #008B8B 100%)',
  gradientSecondary: 'linear-gradient(135deg, #C85A39 0%, #F4A261 100%)',
  gradientBackground: 'linear-gradient(135deg, #FFF8F0 0%, #FFF5E8 100%)',

  // Glass morphism
  glass: 'rgba(255, 255, 255, 0.3)',
  glassBorder: 'rgba(46, 134, 171, 0.2)',
  glassShadow: '0 8px 32px 0 rgba(46, 134, 171, 0.4)',

  // ICOM specific (adapted)
  icomBlue: '#2E86AB',
  icomGold: '#F4A261',
  icomNavy: '#1F5F7A',
  icomLightBlue: '#E8F4F8',
  icomWarmGray: '#FFF5E8',
};

export const mediterraneanDark: ThemeColors = {
  // Primary palette
  primary: '#4A9BC7',
  primaryLight: '#6BB0D4',
  primaryDark: '#2E86AB',

  // Secondary palette
  secondary: '#D97352',
  secondaryLight: '#E68B6F',
  secondaryDark: '#C85A39',

  // Accent colors
  accent: '#F7B885',
  accentLight: '#F9C9A3',
  accentDark: '#F4A261',

  // Neutral palette - Dark with warm undertones
  background: '#1A1612',
  surface: '#25211C',
  surfaceHover: '#2F2A24',

  // Text colors
  text: '#F5EDE0',
  textSecondary: '#D4C4B0',
  textMuted: '#9B8E7A',

  // Status colors
  success: '#4CAF50',
  warning: '#FFB300',
  error: '#EF5350',
  info: '#29B6F6',

  // Border and divider
  border: '#3A342C',
  borderLight: '#2F2A24',
  divider: '#4A4238',

  // Shadows
  shadow: 'rgba(0, 0, 0, 0.4)',
  shadowHover: 'rgba(0, 0, 0, 0.5)',
  shadowDark: 'rgba(0, 0, 0, 0.6)',

  // Overlays
  overlay: 'rgba(0, 0, 0, 0.75)',
  overlayLight: 'rgba(0, 0, 0, 0.4)',

  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #2E86AB 0%, #008B8B 100%)',
  gradientSecondary: 'linear-gradient(135deg, #C85A39 0%, #F4A261 100%)',
  gradientBackground: 'linear-gradient(135deg, #1A1612 0%, #25211C 100%)',

  // Glass morphism
  glass: 'rgba(37, 33, 28, 0.8)',
  glassBorder: 'rgba(74, 155, 199, 0.2)',
  glassShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.6)',

  // ICOM specific
  icomBlue: '#4A9BC7',
  icomGold: '#F7B885',
  icomNavy: '#1F5F7A',
  icomLightBlue: '#2A3A42',
  icomWarmGray: '#2F2A24',
};
